import React from "react";
import ChartGoal from "charts/ChartGoal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import MetricFormatter from "dashboards/MetricFormatter";
import ReactDOMServer from "react-dom/server";

class PdfKeywordRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortBy: "diff",
      sortOrderAsc: true,
      sortedKeywords: [],
    };
  }

  componentDidMount() {
    this.setState({ sortedKeywords: this.props.keywords });
  }

  render() {
    return (
      <div className="mb-2 keyword-ranking-table table-responsive">
        <Table striped className="mt-2 table-white">
          <tbody>
            {this.state.sortedKeywords.map((keyword, i) => {
              let diffBackground = "";
              if (keyword.ranking_difference > 0) diffBackground = "bg-success text-white";
              else if (keyword.ranking_difference < 0) diffBackground = "bg-danger text-white";
              return (
                <tr key={keyword.keyword}>
                  <td>{keyword.keyword}</td>
                  <td>
                    {keyword.serp_features.map((serp_feature) => {
                      if (serp_feature == "rel") return <i key={serp_feature} className="fas fa-question"></i>;
                      if (serp_feature == "rev") return <i key={serp_feature} className="fas fa-star"></i>;
                      if (serp_feature == "fsn") return <i key={serp_feature} className="fas fa-crown"></i>;
                      if (serp_feature == "shp") return <i key={serp_feature} className="fas fa-shopping-cart"></i>;
                      if (serp_feature == "stl") return <i key={serp_feature} className="fas fa-link"></i>;
                      if (serp_feature == "adt") return <i key={serp_feature} className="fas fa-ad"></i>;
                      if (serp_feature == "adb") return <i key={serp_feature} className="fas fa-ad"></i>;
                      if (serp_feature == "vid") return <i key={serp_feature} className="fab fa-youtube"></i>;
                      if (serp_feature == "img") return <i key={serp_feature} className="far fa-images"></i>;
                      if (serp_feature == "geo") return <i key={serp_feature} className="fas fa-globe"></i>;
                      if (serp_feature == "vib") return <i key={serp_feature} className="fas fa-video"></i>;
                      if (serp_feature == "new") return <i key={serp_feature} className="fas fa-newspaper"></i>;
                      if (serp_feature == "twt") return <i key={serp_feature} className="fab fa-twitter-square"></i>;
                      if (serp_feature == "knw") return <i key={serp_feature} className="fas fa-bolt"></i>;
                      if (serp_feature == "kng") return <i key={serp_feature} className="far fa-circle"></i>;
                    })}
                  </td>
                  <td>{keyword.start_date_ranking == 0 ? "100+" : <MetricFormatter.Sessions value={keyword.start_date_ranking} />}</td>
                  <td>{keyword.end_date_ranking == 0 ? "100+" : <MetricFormatter.Sessions value={keyword.end_date_ranking} />}</td>
                  <td className={diffBackground}>
                    <MetricFormatter.Sessions value={keyword.ranking_difference} />
                  </td>
                  <td>
                    <MetricFormatter.CPC value={isNaN(parseFloat(keyword.cpc)) ? 0 : parseFloat(keyword.cpc)} />
                  </td>
                  <td>
                    <MetricFormatter.Sessions value={isNaN(parseFloat(keyword.volume)) ? 0 : parseFloat(keyword.volume)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default PdfKeywordRow;
